import fetch from '@/utils/fetch';
import * as API from '@/commons/http-api';
import { Toast } from 'antd-mobile';
/**
 * 示例模块
 */
export default {
  namespace: 'activationKing',
  state: {
    dayList: '',
    dayListLang: '',
    weekList: '',
    weekListLang: '',
    monthList: '',
    monthListLang: '',
  },
  reducers: {
    setActiveDay(state, action) {
      const { rankingList = [] } = action.payload;
      return {
        ...state,
        dayList: rankingList.slice(0, 10),
      };
    },
    setActiveDayLang(state, action) {
      const { rankingList = [] } = action.payload;
      return {
        ...state,
        dayListLang: rankingList.slice(10, rankingList.length + 1) || '',
      };
    },
    setActiveWeek(state, action) {
      const { rankingList = [] } = action.payload;
      return {
        ...state,
        weekList: rankingList.slice(0, 10),
      };
    },
    setActiveWeekLang(state, action) {
      const { rankingList = [] } = action.payload;
      return {
        ...state,
        weekListLang: rankingList.slice(10, rankingList.length + 1) || '',
      };
    },
    setActiveMonth(state, action) {
      const { rankingList = [] } = action.payload;
      return {
        ...state,
        monthList: rankingList.slice(0, 10),
      };
    },
    setActiveMonthLang(state, action) {
      const { rankingList = [] } = action.payload;
      return {
        ...state,
        monthListLang: rankingList.slice(10, rankingList.length + 1) || '',
      };
    },
  },
  effects: {
    /** 会议数据 排行榜 */
    *getActiveList(action, { put }) {
      const { params } = action.payload;
      Toast.loading('正在加载……');
      let res = '';
      if (params === 'day') {
        res = yield fetch.get(API.GET_ACTIVE_DAY);
      } else if (params === 'week') {
        res = yield fetch.get(API.GET_ACTIVE_WEEK);
      } else if (params === 'month') {
        res = yield fetch.get(API.GET_ACTIVE_MONTH);
      }
      if (res.errorType && res.errorType === 'ERROR') {
        Toast.hide();
        return Toast.fail(res.message);
      } else {
        const { data = [] } = res;
        Toast.hide();
        if (params === 'day') {
          yield put({
            type: 'setActiveDay',
            payload: data,
          });
          yield put({
            type: 'setActiveDayLang',
            payload: data,
          });
        } else if (params === 'week') {
          yield put({
            type: 'setActiveWeek',
            payload: data,
          });
        } else if (params === 'month') {
          yield put({
            type: 'setActiveMonth',
            payload: data,
          });
        }
      }
    },
  },
};
